
import React from "react";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";

interface ServiceSettingsTogglesProps {
  formData: {
    calendar: boolean;
    booking_notifications: boolean;
    review_notifications: boolean;
    published: boolean;
  };
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  editing: boolean;
  service: any;
}

export const ServiceSettingsToggles = ({
  formData,
  setFormData,
  editing,
  service
}: ServiceSettingsTogglesProps) => {
  if (editing) {
    return (
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <Label htmlFor="calendar">Enable Calendar Bookings</Label>
          <Switch
            id="calendar"
            checked={formData.calendar}
            onCheckedChange={(checked) => setFormData(prev => ({ ...prev, calendar: checked }))}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <Label htmlFor="booking_notifications">Booking Notifications</Label>
          <Switch
            id="booking_notifications"
            checked={formData.booking_notifications}
            onCheckedChange={(checked) => setFormData(prev => ({ ...prev, booking_notifications: checked }))}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <Label htmlFor="review_notifications">Review Notifications</Label>
          <Switch
            id="review_notifications"
            checked={formData.review_notifications}
            onCheckedChange={(checked) => setFormData(prev => ({ ...prev, review_notifications: checked }))}
          />
        </div>
        
        <div className="flex items-center justify-between">
          <Label htmlFor="published">Published</Label>
          <Switch
            id="published"
            checked={formData.published}
            onCheckedChange={(checked) => setFormData(prev => ({ ...prev, published: checked }))}
          />
        </div>
      </div>
    );
  }
  
  return (
    <div className="space-y-2">
      <div className="flex justify-between text-sm">
        <span>Calendar Bookings:</span>
        <span>{service.calendar ? "Enabled" : "Disabled"}</span>
      </div>
      <div className="flex justify-between text-sm">
        <span>Booking Notifications:</span>
        <span>{service.booking_notifications !== false ? "Enabled" : "Disabled"}</span>
      </div>
      <div className="flex justify-between text-sm">
        <span>Review Notifications:</span>
        <span>{service.review_notifications !== false ? "Enabled" : "Disabled"}</span>
      </div>
      <div className="flex justify-between text-sm">
        <span>Listing Status:</span>
        <span className={service.published ? "text-green-600" : "text-red-600"}>
          {service.published ? "Published" : "Not Published"}
        </span>
      </div>
    </div>
  );
};
